import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { appRoutes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { BASE_URL } from '@elevate-workspace/auth';
import { themeReducer } from '../store/theme/theme.reducer';
import { ThemeEffects } from '../store/theme/theme.effects';
import {provideTranslateService} from "@ngx-translate/core";
import {provideTranslateHttpLoader} from "@ngx-translate/http-loader";
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { ProductsEffects } from '../store/products/product.efect';
import { productsReducer } from '../store/products/product.reducer';
import { wishlistReducer } from '../store/wishlist/wishlist.reducer';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { tokenInterceptor } from './core/interceptor/token.interceptor';
import { WishlistEffects } from '../store/wishlist/wishlist.effects';
import { cartReducer } from '../store/cart/cart.reducers';
import { CartEffects } from '../store/cart/cart.effects';
export const appConfig: ApplicationConfig = {
  providers: [
    provideClientHydration(withEventReplay()),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes, withInMemoryScrolling({
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled'
  })),
    provideHttpClient(withFetch(),withInterceptors([tokenInterceptor])),
    provideAnimationsAsync(),
     provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        suffix: '.json'
      }),
      fallbackLang: 'en',
      lang: 'en'
    }),
    providePrimeNG({
      theme: {
        preset: Aura,
           options: {
          darkModeSelector: '.dark-mode'
        }
      }
    }),
        provideStore({
      theme: themeReducer,
      products: productsReducer ,
      wishlist: wishlistReducer,
      cart :cartReducer
    }),provideEffects([ThemeEffects,ProductsEffects,WishlistEffects,CartEffects]),
    {
      provide: BASE_URL,
      useValue: 'https://flower.elevateegy.com/'
    },    
  ],
};
